<div *ngIf="finalSubmitPageConfig.residencyHistory && residenceForm">
    <form class="m-form__group" [formGroup]="residenceForm" [attr.data-test-id]="testId + '.form'">
        <h2 class="section-title" [attr.data-test-id]="testId + '.title'">Address History</h2>
        <div formArrayName="residenceAdd">
            <ng-container
                *ngFor="let res of residenceAddArray.controls; let i = index">

                <p class="mb-4 mt-4" *ngIf="i === 1 && finalSubmitPages?.residenceHistoryDuration"
                   [attr.data-test-id]="testId + '.prior-residence-message'">
                    Please add prior residence information. <strong>Minimum {{finalSubmitPages.residenceHistoryDuration}} months</strong> residence history
                    is required.
                </p>

                <div [formGroupName]="i" [attr.data-test-id]="testId + '.entry.' + i">

                    <div class="row">
                        <div class="col-md-12">
                            <creditsnap-address [id]="'address_'+i"
                                                formControlName="addressData" [submitted]="residenceAddArray.controls[i].touched"
                                                (valueChange)="addressChanged($event, residenceAddArray.controls[i])"
                                                [data-test-id]="testId + '.address.' + i"></creditsnap-address>
                        </div>
                        <div class="{{cssWidthClass}}">
                            <mat-form-field class="mat-form-field-fluid">
                                <mat-label [attr.data-test-id]="testId + '.residence-length-label.' + i">Duration at this address</mat-label>
                                <creditsnap-yearmonth #yearmonth id="residenceLength_{{i}}" formControlName="residenceLength"
                                    (focusout)="checkResidenceYears($event, i)"
                                    [data-test-id]="testId + '.residence-length.' + i"
                                    groupLabel="Duration at this address"
                                ></creditsnap-yearmonth>
                                <mat-error [attr.data-test-id]="testId + '.residence-length.required-error.' + i">Please enter residence length.</mat-error>
                                <mat-hint>Enter the residence duration in years and months.</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="{{cssWidthClass}}">
                            <mat-form-field class="mat-form-field-fluid">
                                <mat-label [attr.data-test-id]="testId + '.residence-status-label.' + i">{{contentService.getContentText('REVIEW.RESIDENCE_TEXT') || 'Residence Status'}}</mat-label>
                                <mat-select required
                                            formControlName="residenceStatus" name="residenceStatus" id="residenceStatus_{{i}}"
                                            [attr.data-test-id]="testId + '.residence-status-select.' + i">
                                    <mat-option *ngFor="let status of appConfig.residenceStatusList"
                                                [value]="status.value" id="{{status.value}}"
                                                [attr.data-test-id]="testId + '.residence-status-option.' + status.value?.toLowerCase()">{{status.label}}
                                    </mat-option>
                                </mat-select>
                                <mat-error [attr.data-test-id]="testId + '.residence-status.required-error.' + i">Please select {{contentService.getContentText('REVIEW.RESIDENCE_TEXT') || 'residence status'}}.
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div *ngIf="residenceAddArray.controls.length > 1 && i != 0"
                             class="col-sm-2 d-flex align-items-center">
                            <a mat-flat-button matTooltip="Delete" (click)="removeResidence(i)" id="removePreviousResidenceHistory"
                               [attr.data-test-id]="testId + '.remove-button.' + i">
                                <sm-icon name="trash" [width]="24" [height]="24"></sm-icon>
                            </a>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </form>
</div>

<ng-container *ngIf="appConfig.mailingAddress || (isCoBo && appConfig.coBoMailingAddress)">
    <div class="m-form__group" [attr.data-test-id]="testId + '.mailing-address-container'">
        <h2 class="section-title" [attr.data-test-id]="testId + '.mailing-address-title'">Mailing Address</h2>
        <form #mailingAddressForm="ngForm" [attr.data-test-id]="testId + '.mailing-address-form'">
            <div class="row" *ngIf="isCoBo && appConfig.coBoMailingAddressSameAsPrimary && primaryMailingAddress?.streetAddress">
                <div class="col-sm-12 text-start">
                    <mat-checkbox name="sameMailingAsPrimary" [checked]="sameMailingAsPrimary"
                                  [(ngModel)]="sameMailingAsPrimary" (change)="onSameAsPrimaryAddressChange()"
                                  [attr.data-test-id]="testId + '.same-as-primary-mailing-address-checkbox'">
                        Mailing address is same as the primary applicant's mailing address
                    </mat-checkbox>
                </div>
            </div>

            <!-- Checkbox should only show if address was previously collected -->
            <!-- Applicant: address is always collected on personal info page -->
            <!-- Co-applicant: address is only collected when residenceHistory is enabled -->
            <div class="row mt-3" *ngIf="!sameMailingAsPrimary && !mailingAddressData.addressId && (!isCoBo || finalSubmitPageConfig.residencyHistory)">
                <div class="col-sm-12 text-start">
                    <mat-checkbox name="sameMailAddress" [checked]="sameMailAddress"
                                  [(ngModel)]="sameMailAddress"
                                  [attr.data-test-id]="testId + '.same-mailing-address-checkbox'">
                        Mailing address is same as the current address already provided
                    </mat-checkbox>
                </div>
            </div>

            <!-- Address form shown when checkbox unchecked, or when checkbox is hidden (co-applicant without residence history) -->
            <div *ngIf="!sameMailingAsPrimary && (!sameMailAddress || (isCoBo && !finalSubmitPageConfig.residencyHistory))">
                <div class="row mt-3">
                    <div class="col-md-12">
                        <creditsnap-address #mailingAddress [submitted]="mailingAddressForm.form.touched" name="mailingAddressData"
                                            [(ngModel)]="mailingAddressData" [isMailingAddress]="true"
                                            [data-test-id]="testId + '.mailing-address'"></creditsnap-address>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-container>

